// postMessage contract with the Canvas iframe: `event` is what either side posts as
// { event: { type, ... } }.
export const CANVAS_EVENTS = {
  // iframe → us
  ready: "all_actions_complete",
  sceneModified: "scene_modified",
  screenshot: "screenshot",
  // us → iframe
  setScene: "set_scene",
  setToken: "set_token",
  setViewportMode: "set_viewport_mode",
  getScreenshot: "get_screenshot",
};

export const SCREENSHOT_TIMEOUT = 15000;
